import React from 'react';

import * as S from './LoadingCell.styles';

export const LoadingCell = () => {
  return (
    <S.Root>
      <S.LeftWrapper>
        <S.LogoLoader />
        <S.NameLoader />
      </S.LeftWrapper>
      <S.RightWrapper>
        <S.RankLoader />
      </S.RightWrapper>
    </S.Root>
  );
};
